import React from 'react';
import './index.css';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Navbar, Sidebar } from '../../components';
import CardDashboard from './CardDashboard';
import MaterialUISwitch from '../../components/MaterialUISwitch';
import AlertsTabs from '../alerts/ds/AlertsTabs';

function UserDashboard() {
  const [isChecked, setIsChecked] = React.useState(false);

  const handleSwitchChange = (event) => {
    setIsChecked(event.target.checked);
    // localStorage.setItem('tabularDashboard', event.target.checked);
  };

  // useEffect(() => {
  //   const tabularDashboard = localStorage.getItem('tabularDashboard');
  //   if (tabularDashboard === 'true') {
  //     setIsChecked(true);
  //   }
  // }, []);

  return (
    <>
      <Navbar />
      <Sidebar />
      <div style={{ height: 'auto' }} className="screen-wrapper">
        <div className="screen-header insights">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-4" data-tour="dashboard">
            <h3
              className="header-manage-member"
              style={{ width: 'auto', flex: '1 1 auto', minWidth: 0 }}
            >
              Shoot Insights
            </h3>
            <FormGroup sx={{ flexShrink: 0 }} data-tour="dashboard-view">
              <FormControlLabel
                control={(
                  <MaterialUISwitch
                    sx={{ m: 1 }}
                    checked={isChecked}
                    onChange={handleSwitchChange}
                  />
              )}
                label=""
                sx={{ marginRight: 0 }}
              />
            </FormGroup>
          </div>
          {isChecked ? <AlertsTabs /> : <CardDashboard onViewAlerts={() => setIsChecked(true)} />}
        </div>
      </div>
    </>
  );
}

export default UserDashboard;
